import React from 'react';
import { useAuthStore } from '../store/authStore';
import { useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { urlImports, urlClientSurvey, urlFizen } from '../config';
import {
    Box,
    Typography,
    Paper,
    Stack,
    Input
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import Controls from './controls/Controls';

const useStyles = makeStyles(() => ({
    pageContent: {
        marginTop: 20,
    },
}));

function Imports() {
    const { token: token } = useAuthStore();

    const [selectedFile, setSelectedFile] = useState(null);
    const [file, setFile] = useState(null);
    const excelInputRef = React.useRef();
    const surveyInputRef = React.useRef();
    const [surveyId, setSurveyId] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [loading1, setLoading1] = useState(false);
    const [loadingLinking, setLoadingLinking] = useState(false);
    const [bankId, setBankId] = useState("mbank");
    const [clientId, setClientId] = useState("371");
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const classes = useStyles();
    const roles = useAuthStore().roles;
    
    const uploadExcelToBackend = async (file) => {
        const formData = new FormData();
        formData.append("file", file);

        try {
            const response = await fetch(urlImports + '/import-financial-reports-excel', {
                method: "POST",
                body: formData,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error("Błąd podczas wysyłania pliku");
            }

            // Pobierz plik jako blob
            const blob = await response.blob();

            // Utwórz URL do pobrania
            const url = window.URL.createObjectURL(blob);

            // Stwórz link do pobrania
            const link = document.createElement("a");
            link.href = url;
            link.download = "wyniki_sprawozdania.xlsx";
            document.body.appendChild(link);
            link.click();

            // Sprzątnij
            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            alert("Wystąpił błąd: " + error.message);
        }
    };

    const handleBackendUpload = () => {
        if (!selectedFile) {
            setMessage("Wybierz plik Excel");
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            return;
        }
        setLoading(true);
        uploadExcelToBackend(selectedFile)
            .then(() => {
                setSelectedFile(null);
                if (excelInputRef.current) excelInputRef.current.value = "";
                setMessage("Plik został pomyślnie wysłany.");
                setSnackbarSeverity('success');
                setSnackbarOpen(true);
            })
            .catch((error) => {
                setMessage("Wystąpił błąd: " + error.message);
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    const handleUpload = async () => {
        if (!file) {
            setMessage("Wybierz plik ankiety");
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            return;
        }
        if (!surveyId) {
            setMessage("Wpisz identyfikator ankiety");
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            return;
        }

        setLoading1(true);
        const formData = new FormData();
        formData.append("file", file);
        formData.append("month", surveyId);

        try {
            const response = await fetch(urlClientSurvey + "/upload", {
                method: "POST",
                body: formData,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok) {
                // backend zwraca int → trzeba sparsować jako tekst a potem na liczbę
                const text = await response.text();
                const imported = parseInt(text, 10);
                setMessage(`Plik został pomyślnie załadowany do bazy.`);
                setSnackbarSeverity('success');
                setSnackbarOpen(true);
                setFile(null);
                setSurveyId("");
                if (surveyInputRef.current) surveyInputRef.current.value = "";
            } else {
                // backend zwraca String w przypadku błędu
                const errorMessage = await response.text();
                setMessage(errorMessage);
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
            }
        } catch (error) {
            setMessage("Błąd połączenia z serwerem: " + error.message);
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
        } finally {
            setLoading1(false);
        }
    };

    const startLinking = async () => {
        setLoadingLinking(true);
        try {
            const url = new URL(`${urlFizen}/start`);
            url.searchParams.append("bankId", bankId);
            url.searchParams.append("clientId", clientId);

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(errorText || "Błąd podczas rozpoczynania łączenia");
            }

            const data = await response.json();
            if (data.redirectUri) {
                window.location.href = data.redirectUri;
            } else {
                throw new Error("Brak linku przekierowania w odpowiedzi");
            }
        } catch (error) {
            setMessage("Wystąpił błąd: " + error.message);
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
        } finally {
            setLoadingLinking(false);
        }
    };

    return (
        <>
            <Paper className={classes.pageContent} elevation={0}>
                <Snackbar open={snackbarOpen} autoHideDuration={5000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                    <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
                        {message}
                    </Alert>
                </Snackbar>
                <Box
                    sx={{
                        maxWidth: 800,
                        mx: 'auto',
                        p: 4,
                    }}
                >
                    <Paper
                        elevation={3}
                        sx={{
                            p: 4,
                            borderRadius: 3,
                        }}
                    >
                        <Typography variant="h5" gutterBottom >
                            Excel → API (sprawozdania - rejestr.io) → Excel
                        </Typography>
                        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                            Załaduj dane firmy w Excelu, aby uzyskać zwrotny plik z ostatnimi złożonymi sprawozdaniami. Plik ładowany powinien zawierać 2 kolumny bez nagłówków - pierwsza nip, druga nazwa fimy.
                        </Typography>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: 'stretch', sm: 'center' }}>
                            <Input
                                type="file"
                                inputProps={{ accept: '.xlsx' }}
                                inputRef={excelInputRef}
                                onChange={e => setSelectedFile(e.target.files[0])}
                                disableUnderline
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: 1,
                                    border: '1px solid',
                                    width: '100%',
                                    maxWidth: 400,
                                }}
                            />
                            <Controls.PremiumButton
                                variant="green"
                                label={loading ? 'Ładowanie...' : 'Wyślij plik'}
                                onClick={handleBackendUpload}
                                disabled={loading}
                                icon={loading ? "fas fa-spinner fa-spin" : "fas fa-upload"}
                                sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: { sm: 160 } }}
                            />
                        </Stack>
                    </Paper>
                </Box>
                <Box
                    sx={{
                        maxWidth: 800,
                        mx: 'auto',
                        p: 4,
                    }}
                >
                    <Paper
                        elevation={3}
                        sx={{
                            p: 4,
                            borderRadius: 3,
                        }}
                    >
                        <Typography variant="h5" gutterBottom >
                            Excel → Ankieta
                        </Typography>
                        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                            Załaduj ankietę w Excelu.
                        </Typography>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: 'stretch', sm: 'center' }}>
                            <Input
                                type="file"
                                inputProps={{ accept: '.xlsx' }}
                                inputRef={surveyInputRef}
                                onChange={e => setFile(e.target.files[0])}
                                disableUnderline
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: 1,
                                    border: '1px solid',
                                    width: '100%',
                                    maxWidth: 400,
                                }}
                            />
                             <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', maxWidth: { xs: '100%', sm: 200 } }}>
                                <Typography variant="body2" sx={{ mb: 0.5 }}>
                                    Nadaj identyfikator
                                </Typography>
                                <Input
                                    type="text"
                                    placeholder="np. 2025-09"
                                    value={surveyId}
                                    onChange={(e) => setSurveyId(e.target.value)}
                                    sx={{ width: '100%' }}
                                />
                            </Box>
                            <Controls.PremiumButton
                                variant="green"
                                label={loading1 ? 'Ładowanie...' : 'Wyślij plik'}
                                onClick={handleUpload}
                                disabled={loading1}
                                icon={loading1 ? "fas fa-spinner fa-spin" : "fas fa-upload"}
                                sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: { sm: 160 } }}
                            />
                        </Stack>
                    </Paper>
                </Box>
                <Box
                    sx={{
                        maxWidth: 800,
                        mx: 'auto',
                        p: 4,
                    }}
                >
                    <Paper
                        elevation={3}
                        sx={{
                            p: 4,
                            borderRadius: 3,
                        }}
                    >
                        <Typography variant="h5" gutterBottom >
                            Fizen → Połącz konto bankowe (Start Linking)
                        </Typography>
                        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                            Inicjuj połączenie z wybranym kontem bankowym klienta. System przekieruje Cię do strony autoryzacji banku.
                        </Typography>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: 'stretch', sm: 'flex-end' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', maxWidth: { xs: '100%', sm: 200 } }}>
                                <Typography variant="body2" sx={{ mb: 0.5 }}>
                                    Identyfikator banku (bankId)
                                </Typography>
                                <Input
                                    type="text"
                                    placeholder="np. mbank"
                                    value={bankId}
                                    onChange={(e) => setBankId(e.target.value)}
                                    sx={{ width: '100%' }}
                                />
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', maxWidth: { xs: '100%', sm: 200 } }}>
                                <Typography variant="body2" sx={{ mb: 0.5 }}>
                                    Identyfikator klienta (clientId)
                                </Typography>
                                <Input
                                    type="text"
                                    placeholder="np. 371"
                                    value={clientId}
                                    onChange={(e) => setClientId(e.target.value)}
                                    sx={{ width: '100%' }}
                                />
                            </Box>
                            <Controls.PremiumButton
                                variant="blue"
                                label={loadingLinking ? 'Inicjowanie...' : 'Uruchom start linking'}
                                onClick={startLinking}
                                disabled={loadingLinking}
                                icon={loadingLinking ? "fas fa-spinner fa-spin" : "fas fa-link"}
                                sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: { sm: 200 } }}
                            />
                        </Stack>
                    </Paper>
                    <Box sx={{ m: '220px' }} />
                </Box>
            </Paper>
        </>
    );
}

export default Imports;